import { render, staticRenderFns } from "./mcq.vue?vue&type=template&id=a5a81366&scoped=true&"
import script from "./mcq.vue?vue&type=script&lang=js&"
export * from "./mcq.vue?vue&type=script&lang=js&"
import style0 from "./mcq.vue?vue&type=style&index=0&id=a5a81366&prod&lang=css&"
import style1 from "./mcq.vue?vue&type=style&index=1&id=a5a81366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a81366",
  null
  
)

export default component.exports